<template>
  <div class="automatic-course-scheduling">
    <!-- 科目列表栏 -->
    <div class="curriculum-management-topbar" v-loading="isCourseModuleListLoading">
      <div class="topbar-title-container">
        <div class="topbar-title">
          <i class="iconfont icon-tips"></i>请选择科目
        </div>
        <!-- <div class="comeback-button-cotainter">
          <button
            class="comeback-button"
            v-if="isComebackButtonShow"
            @click="setCourseListAgain"
          >
            <i class="iconfont icon-refresh comeback-icon" />重新设置科目
          </button>
        </div> -->
      </div>
      <div class="topbar-course-list-container">
        <div class="course-item-container" v-for="item in autoMaticCourseList" :key="`course-${item.courseId}`"
          :class="{ select: item.isSelect }" @click="courseSelect(item)" v-if="item.courseName !== '总分'">
          <img :src="$courseList[item.courseName]
            ? $courseList[item.courseName].courseIcon
            : $courseList['其他'].courseIcon
            " class="course-icon" />
          <span class="course-name">{{ item.courseName }}</span>
          <div class="course-select-tag" v-show="item.isSelect">
            <i class="iconfont icon-complete icon" />
          </div>
        </div>
      </div>
    </div>
    <!-- 排课条件选项 -->
    <div class="class-list">
      <div v-for="(itemS, indexS) in schoolClassList" :key="itemS.classId" class="classItem">
        <div class="class-text">{{ itemS.className }}：</div>
        <div v-for="(item, index) in itemS.courseInfo" :key="`${itemS.classId}-${item.courseId}`"
          class="subject-scheduling-item">
          <div>科目：{{ item.courseName }}</div>
          <div>
            教师：
            <select v-model="item.teacherId" class="select" @change="teacherChange(item, indexS)">
              <option v-if="itemS.teacherList.length === 0" disabled selected value="">
                暂无教师列表
              </option>
              <option v-for="(teacher, index) in itemS.teacherList"
                :key="`${itemS.classId}-teacher-${teacher.teacherId}-${index}`" :value="teacher.teacherId">
                {{ teacher.teacherName }}
              </option>
            </select>
          </div>
          <div>
            课室：
            <select v-model="item.classroomId" class="select" @change="classRoomChange(item)">
              <option v-for="course in classroomList" :key="`classroom-${course.id}`" :value="course.id">
                {{ course.classroomName }}
              </option>
            </select>
          </div>
          <!-- <div>
            每周课节：
            <input type="text" placeholder="请输入" v-model.trim="item.weeklyMaxHour" class="input" />
          </div> -->
          <div>
            每周课节：
            <input type="text" placeholder="请输入" v-model.trim="item.weeklyMaxHour" class="input" />
          </div>
          <div>
            连排次数：
            <input type="text" placeholder="请输入" v-model.trim="item.weeklySerialNumber" class="input" />
          </div>
          <div>
            每天至多课节：
            <input type="text" placeholder="请输入" v-model.trim="item.dailyMaxHour" class="input" />
          </div>
          <div>
            每天至少课节：
            <input type="text" placeholder="请输入" v-model.trim="item.dailyLeastHour" class="input" />
          </div>
          <div>
            至少第几节前：
            <input type="text" placeholder="请输入" v-model.trim="item.leastLessonsBefore" class="input" />
          </div>
          <div>
            至少第几节后：
            <input type="text" placeholder="请输入" v-model.trim="item.leastLessonsAfter" class="input" />
          </div>
          <div>
            <el-tooltip class="item" effect="dark" content="按住Ctrl键（在Windows系统中）或Command键（在Mac系统中）实现多选" placement="top">
              <span> 禁止排课节：</span>
            </el-tooltip>
            <select v-model="item.excludedLessons" multiple class="select" style="height: 55px;">
              <option v-for="lessonNumber in lessonNumbers" :key="lessonNumber" :value="lessonNumber">
                {{ lessonNumber }}
              </option>
            </select>
          </div>
          <div>
            单节最大并行数：
            <input type="text" placeholder="请输入" v-model.trim="item.maxParallel" class="input" />
          </div>
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <div class="submit-container" v-hasPermi="'sc:coursearrange:edit'">
      <button class="submit-button" @click="reset">重置</button>
      <button class="submit-button" @click="saveDraft(1)">保存草稿</button>
      <button class="submit-button" @click="readDraft">读取草稿</button>
      <button class="submit-button" @click="submit" v-hasPermi="'sc:coursearrange:edit'">
        生成
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      //默认课程表的课节行数
      defaultLessonNumber: 8,
      // 选中后的班级年级
      className: [],
      // 自动排课输入框尺寸
      inputSize: "mini",
    };
  },
  props: {
    //科目模块列表数据
    courseList: {
      type: Array,
    },
    schoolClassList: {
      type: Array,
    },
    classroomList: {
      type: Array,
    },
    teacherList: {
      type: Array,
    },
    courseConstructionNum: {
      type: Number,
    },
    coursePlanDailyMaxNum: {
      typeof: Number,
    },
    gradeSelect: {
      type: Object,
    },
    autoMaticCourseList: {
      type: Array,
    },
    isCourseModuleListLoading: {
      type: Boolean,
    },
    isComebackButtonShow: {
      type: Boolean,
    },
  },
  computed: {
    // 计算属性：生成从 1 到 courseConstructionNum 的数字数组
    lessonNumbers() {
      const num = Number(this.coursePlanDailyMaxNum) || 0;
      return Array.from({ length: num }, (_, i) => i + 1);
    }
  },
  methods: {
    // 保存草稿
    saveDraft(num) {
      if (!this.schoolClassList.length)
        return this.$message.warning("请选择年级");

      // 检测是否所有的courseInfo都为空
      const allCoursesEmpty = this.schoolClassList.every((item) => {
        return item.courseInfo.every((course) => {
          return course === null || course === undefined; // 根据你的数据结构，可以调整判断条件
        });
      });

      // 如果所有的courseInfo都为空，则提示
      if (allCoursesEmpty) {
        return this.$message.warning("请选择科目");
      }

      let data = {
        schoolId: this.user.schoolId,
        schoolName: this.user.schoolName,
        gradeId: this.gradeSelect.gradeId,
        gradeCode: this.gradeSelect.gradeCode,
        gradeName: this.gradeSelect.gradeName,
        classInfo: this.schoolClassList,
      };

      this.post(this.$url.saveAutoSchedulingCondition, data).then((res) => {
        // console.log("保存草稿：", res);
        if (num == 2) {
          return
        }
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      });
    },
    // 读取草稿
    readDraft() {
      if (!this.schoolClassList.length)
        return this.$message.warning("请选择年级");
      this.get(this.$url.getAutoSchedulingCondition + '?gradeId=' + this.gradeSelect.gradeId).then((res) => {
        // console.log("读取草稿：", res);
        if (res.code !== 200 || res.data == null) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.$emit("schoolClassListRead", res.data.classInfo);

        // 设置科目选中
        res.data.classInfo[0].courseInfo.forEach((item) => {
          this.autoMaticCourseList.forEach(course => {
            if (course.courseId == item.courseId) {
              // 设置是否选择
              Vue.set(course, "isSelect", !course.isSelect);
            }
          })
        });
        // 设置科目后重新过滤
        this.filterChooseCourse();
      });
    },
    classRoomChange(data) {
      data.classroomName = this.classroomList.find(
        (item) => item.id == data.classroomId
      ).classroomName;
    },
    teacherChange(data, index) {
      let teacherList = this.schoolClassList[index].teacherList;
      data.teacherName = teacherList.find(
        (item) => item.teacherId == data.teacherId
      ).teacherName;
      data.teacherNumber = teacherList.find(
        (item) => item.teacherId == data.teacherId
      ).teacherNumber;
      // console.log("教师选择：", data, index, teacherList);
    },
    // 自动排课点击提交
    submit() {
      // 检测班级总课时是否大于最大课时数
      // let overlist = [];
      // this.schoolClassList.forEach((item) => {
      //   item["sum"] = 0;
      //   item.courseInfo.forEach((itemS) => {
      //     item["sum"] += +itemS.weeklyMaxHour;
      //   });
      //   // console.log("item:", item["sum"]);
      //   if (item["sum"] > this.courseConstructionNum) {
      //     overlist.push(item.className);
      //   }
      // });

      // if (overlist.length) {
      //   let exceedClass = overlist.join("，");
      //   this.$message.warning(exceedClass + "的课时大于最大课时，请重新设置！");
      // }
      if (!this.schoolClassList.length)
        return this.$message.warning("请选择年级");

      // 检测是否所有的courseInfo都为空
      const allCoursesEmpty = this.schoolClassList.every((item) => {
        return item.courseInfo.every((course) => {
          return course === null || course === undefined; // 根据你的数据结构，可以调整判断条件
        });
      });

      // 如果所有的courseInfo都为空，则提示
      if (allCoursesEmpty) {
        return this.$message.warning("请选择科目");
      }

      let data = {
        schoolId: this.user.schoolId,
        schoolName: this.user.schoolName,
        gradeId: this.gradeSelect.gradeId,
        gradeCode: this.gradeSelect.gradeCode,
        gradeName: this.gradeSelect.gradeName,
        classInfo: this.schoolClassList,
      };
      // console.log("data:", data);

      this.post(this.$url.automaticCourseScheduling, data).then((res) => {
        // console.log("自动排课点击生成==>", res);
        // if (res.code !== 200) {
        //   return this.$message.error(res.data[0]);
        // }
        // this.$message.success("生成成功");
        this.saveDraft(2);
        this.$emit("automaticCourseScheduling", res);
      });
    },
    // 重置点击
    reset() {
      this.$emit("reset");
    },
    courseSelect(courseItem) {
      // console.log("this.schoolClassList:", this.schoolClassList);
      // 判断是否选择年级
      if (!this.schoolClassList.length)
        return this.$message.warning("请选择年级");
      // 设置是否选择
      Vue.set(courseItem, "isSelect", !courseItem.isSelect);
      // 重新过滤
      this.filterChooseCourse();
    },
    filterChooseCourse() {
      // console.log("this.autoMaticCourseList:", this.autoMaticCourseList);
      // 遍历 schoolClassList
      this.schoolClassList.forEach((itemS) => {
        // console.log("items:", itemS);
        // 清空 courseInfo

        const selectedCourseSet = new Set();
        itemS["courseInfo"] = itemS["courseInfo"].filter((item) => {
          // 如果已经选择，则返回true
          if (!selectedCourseSet.has(item.courseName)) {
            selectedCourseSet.add(item.courseName);
            return true;
          }
          return false;
        });

        // 遍历 autoMaticCourseList
        this.autoMaticCourseList.forEach((item, index) => {
          // 如果已经选择，则返回true
          if (item.isSelect && !selectedCourseSet.has(item.courseName)) {
            itemS["courseInfo"].push({
              courseName: item.courseName,
              courseId: item.courseId,
              courseIcon: item.courseIcon || "",
              teacherId: item.teacherId || "",
              teacherNumber: item.teacherNumber || "",
              teacherName: item.teacherName || "",
              classroomId: item.classroomId || "",
              classroomName: item.classroomName || "",
              weeklyMaxHour: "",
              dailyMaxHour: "",
              dailyLeastHour: "",
              weeklySerialNumber: "",
              leastLessonsBefore: this.coursePlanDailyMaxNum + 1,
              leastLessonsAfter: 0,
              maxParallel: "",
              excludedLessons: []
            });
            selectedCourseSet.add(item.courseName);
          } else if (!item.isSelect && selectedCourseSet.has(item.courseName)) {
            let index = itemS["courseInfo"].findIndex(
              (obj) => obj.courseName == item.courseName
            );
            selectedCourseSet.delete(item.courseName);
            itemS["courseInfo"].splice(index, index + 1);
          }
        });
      });

      // console.log("this.schoolClassList:", this.schoolClassList);
    },
    //点击重新编辑科目按钮，回到第一步
    setCourseListAgain() {
      let data = {
        defaultLessonNumber: this.defaultLessonNumber,
        className: this.className,
      };
      this.$emit("setCourseListAgain", data);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./automatic-course-scheduling.scss";
</style>